import React from 'react';
import Spinner from '../Spinner';
import Table from '../Table';

const HEAD_CELLS = [
  {
    id: 'id',
    numeric: false,
    disabledPadding: true,
    label: 'Ordinal No',
  },
  {
    id: 'client',
    numeric: false,
    disabledPadding: false,
    label: 'Client',
  },
  {
    id: 'elevator',
    numeric: false,
    disabledPadding: false,
    label: 'Elevator',
  },
  {
    id: 'address',
    numeric: false,
    disabledPadding: false,
    label: 'Address',
  },
  {
    id: 'project',
    numeric: false,
    disabledPadding: false,
    label: 'Project',
  },
  {
    id: 'period',
    numeric: false,
    disabledPadding: false,
    label: 'Period',
  },
  {
    id: 'elevatorId',
    numeric: false,
    disabledPadding: false,
    label: 'Elevator ID',
  },
  {
    id: 'createdBy',
    numeric: false,
    disabledPadding: false,
    label: 'Created By',
  },
  {
    id: 'createdAt',
    numeric: false,
    disabledPadding: false,
    label: 'Created at',
  },
  {
    id: 'actions',
    numeric: false,
    disabledPadding: true,
    label: 'Actions',
  },
  {
    id: 'sendAction',
    numeric: false,
    disabledPadding: true,
    label: 'Send Mail',
  },
];

const DATA_CELLS = [
  'id',
  'client',
  'elevator',
  'address',
  'project',
  'period',
  'elevatorId',
  'createdBy',
  'createdAt',
  'viewAction',
  'sendAction'
];

const PdfsReportTable = ({
  list,
  dataCells = DATA_CELLS,
  headCells = HEAD_CELLS,
  onRowClick,
  handleSendEmail,
  loading,
}) => {
  if (loading) {
    return <Spinner />;
  }


  return (
    <Table
      data={list}
      dataCells={dataCells}
      headCells={headCells}
      onRowClick={onRowClick}
      noToolbar
      noSort
      getObject
      handleSendEmail={handleSendEmail}
    />
  );
};

export default PdfsReportTable;
